import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import './styles.scss';
import { humanizeInspectableType, isKnownAssetType } from '../../utils/humanizeInspectableType';
const SKIP_KEYS = new Set(['id', 'uuid', 'type', 'createdAt', 'updatedAt', 'created_at', 'updated_at']);
function shouldSkipKey(key) {
    if (SKIP_KEYS.has(key))
        return true;
    if (/Id$|Ids$|_id$|_ids$/i.test(key))
        return true;
    return false;
}
function formatKey(key) {
    // Handle snake_case first, then camelCase
    const underscored = key.replace(/_([a-z])/g, (_, c) => ` ${c.toUpperCase()}`);
    return underscored
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .replace(/\s+/g, ' ');
}
export default function DeviceInfoToggle({ inspectable, onToggle }) {
    const [isExpanded, setIsExpanded] = useState(true);
    if (!inspectable || !inspectable.data || Object.keys(inspectable.data).length === 0) {
        return null;
    }
    if (!isKnownAssetType(inspectable.type)) {
        return null;
    }
    const displayEntries = Object.entries(inspectable.data).filter(([key, value]) => {
        if (shouldSkipKey(key))
            return false;
        if (value == null || value === '')
            return false;
        if (typeof value === 'object')
            return false;
        return true;
    });
    if (displayEntries.length === 0)
        return null;
    const toggleExpanded = (e) => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
        onToggle(e);
    };
    return (React.createElement("details", { className: "qmb-accordion", open: isExpanded },
        React.createElement("summary", { onClick: toggleExpanded }, translate('device_information', { namespace: 'features.iim_review.issue_card' })),
        React.createElement("div", { className: "issue-card__device-info-content" },
            React.createElement("div", { className: "issue-card__device-info-item" },
                React.createElement("span", { className: "issue-card__device-info-label" },
                    translate('type', { namespace: 'features.iim_review.issue_card' }),
                    ":"),
                React.createElement("span", { className: "issue-card__device-info-value" }, humanizeInspectableType(inspectable.type))),
            displayEntries.map(([key, value]) => (React.createElement("div", { key: key, className: "issue-card__device-info-item" },
                React.createElement("span", { className: "issue-card__device-info-label" },
                    formatKey(key),
                    ":"),
                React.createElement("span", { className: "issue-card__device-info-value" }, String(value))))))));
}
